import { render } from "./Tizhikuorong.vue?vue&type=template&id=1a1d9926&scoped=true"
import script from "./Tizhikuorong.vue?vue&type=script&lang=js"
export * from "./Tizhikuorong.vue?vue&type=script&lang=js"

import "./Tizhikuorong.vue?vue&type=style&index=0&id=1a1d9926&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1d9926"]])

export default __exports__